import React, {  useEffect, useState} from 'react';

import GamePage from './GamePage';
import MainMenuPage from './MainMenuPage';
import CoreControlledMainUI from '../cvp-webgames-core/Components/ui/react/core-controlled/core-controlled-main-ui';
import Tools from '../cvp-webgames-core/Misc/Tools';
import { VideoSegmentManager } from '../cvp-webgames-core/VideoSegment/VideoSegmentManager';
import { useWindowSize } from '../cvp-webgames-core/hooks/useWindowSize';
import { PreCacheManager } from '../cvp-webgames-core/pre-caching/pre-cache-manager';
import { constants } from '../misc/constants';
import { globals } from '../misc/globals';
import { PageType, generalAudioCaching, updateGlobalTextSize } from '../misc/tools';
import { savingUICaching } from '../components/ui/saving-ui';
import { welcomeWindowCaching } from '../components/ui/welcome-window';
import {scenario1VideoSegments } from '../scenarios/scenario1';
import { scenario2VideoSegments } from '../scenarios/scenario2';
import { scenario3VideoSegments } from '../scenarios/scenario3';
import { scenario4VideoSegments } from '../scenarios/scenario4';
import { scenario5VideoSegments } from '../scenarios/scenario5';
import { gameBaseScenarioGeneralCaching } from '../scenarios/GameBaseScenario';
import { mixedMediaUICaching } from '../components/ui/mentor-ui';
import { mixedMediaUIImgCaching } from '../components/ui/media-controls-ui';

Tools.updateTextSize();

// setInterval(() => {
// 	var videos = document.getElementsByTagName('video');
// 	var counterMuted = 0;
// 	var counterUnmuted = [];
// 	for(var indx = 0; indx < videos.length; indx++) {
// 		if(videos[indx].muted) {
// 			counterMuted++;
// 		} else {
// 			counterUnmuted.push(videos[indx].src);
// 		}
// 	}

// 	console.log('muted: ' + counterMuted);
// 	console.log(counterUnmuted)
// }, 5000)

const MainPage = () => {
	const [windowToUse, setWindowToUse] = useState(PageType.Nothing.toString());
	let isInitializing: boolean = false;

	const windowSize: any = useWindowSize();

	const scale = Math.min(windowSize.width / 1920, windowSize.height / 1080);
	globals.worldScale = scale;

	const preCacheManager = new PreCacheManager();
	const videoSegmentManager = new VideoSegmentManager();

	const registerItemsToPreCache = () => {
		preCacheManager.registerItem(generalAudioCaching);
		preCacheManager.registerItem(gameBaseScenarioGeneralCaching);
		preCacheManager.registerItem(mixedMediaUIImgCaching);
		preCacheManager.registerItem(welcomeWindowCaching);
	}

	const registerVideoSegments = () => {
		videoSegmentManager.registerItem(mixedMediaUICaching);
		videoSegmentManager.registerItem(scenario1VideoSegments);
		videoSegmentManager.registerItem(scenario2VideoSegments);
		videoSegmentManager.registerItem(scenario3VideoSegments);
		videoSegmentManager.registerItem(scenario4VideoSegments);
		videoSegmentManager.registerItem(scenario5VideoSegments);
		preCacheManager.registerVideoSegmentManager(videoSegmentManager);
	}

	const onLoadSite = () => {
		let url = new URL(window.location.href);
		let search_params = url.searchParams;
		let w: any = search_params.get('w');
		if(w && w !== PageType.Nothing) {
			setWindowToUse(w);
		} else {
			setWindowToUse(PageType.MainMenu);
		}
		setTimeout(() => {
			(window as any)['uiContainerChanged']();
		}, 0);
	}

	useEffect(() => {
		if(!isInitializing) {
			isInitializing = true;
			// if(localStorage.getItem('did-precache')) {
				registerItemsToPreCache();
				registerVideoSegments();
				onLoadSite();
			// } else {
			// 	setWindowToUse(PageType.MainMenu);
			// }
			
			updateGlobalTextSize();
		}
	})

	return (
		<div style={{
			position: 'relative',
			top: '0',
			left: '0',
		}}>
			<div style={{
				position: "fixed",
				width: "1920px",
				height: "1080px",
				transform: `scale(${scale}) translate(-50%, -50%)`,
				transformOrigin: "0px 0px",
				top: "50%",
				left: "50%",
				overflow: 'hidden'
			}} id="game-root-page-obj">
				<div id="main-bg-img" style={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					// background: "#000000 url(./assets/bg.png) no-repeat center center"
					background: "#000000"
					}}>

				</div>
				<div style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}>
					{windowToUse === PageType.MainMenu ? <MainMenuPage updateWindow={Tools.updateWindow} preCacheManager={preCacheManager}></MainMenuPage> : (null)}
					{windowToUse.toLocaleLowerCase().indexOf('main menu') === -1 && windowToUse.toLocaleLowerCase().indexOf('nothing') === -1 ? <GamePage updateWindow={Tools.updateWindow} scenarioId={windowToUse.toString()}></GamePage> : (null)}
				</div>
				<CoreControlledMainUI debugMode={constants.debugMode} videoSegmentManager={videoSegmentManager}></CoreControlledMainUI>
			</div>
		</div>
		
	);
};

export default MainPage;
